import { eksmoBP } from 'Lib/bp/bp';
import 'jquery-easing';
import { speed } from 'Lib/speed/speed';
import { getW } from 'Lib/w/w';
import { onScreen } from 'Lib/on-screen/on-screen';
import { loadSrcOrBg } from 'Lib/load-src-or-bg/load-src-or-bg';
import 'imports-loader?wrapper=window!jquery-throttle-debounce'; // eslint-disable-line import/no-extraneous-dependencies, import/no-webpack-loader-syntax
import 'Vendor/owlcarousel/owl.carousel.min';

const $fixedMenu = $('.timeline__scroll-v');
const cSliderOn = 'owl-carousel';
const sSlider = '.timeline__scroll-slider';
const $slider = $(sSlider);
const sLink = '.timeline__scroll-item';
const cLinkActive = 'timeline__scroll-item_active';
const sLinkV = '.timeline__scroll-v-item';
const cLinkVActive = 'timeline__scroll-v-item_active';
let activeNum = 0;
const $arrow = $('.timeline__arrow');
const $section = $('.timeline__line-item[data-num]');
const $link = $(sLink);
const $linkV = $(sLinkV);
const $scroll = $('.timeline__scroll');
const $scrollFF = $scroll.find('.timeline__scroll-ff').first();
const cScrollFFFixed = 'timeline__scroll-ff_fixed';
const $headerPic = $('.timeline__header-pic-m, .timeline__header-pic-d');
const cHeaderPicDLoaded = 'timeline__header-pic-d_loaded';
const sectionArr = [];
const $spoilerLink = $('.timeline__spoiler-link');
const sSpoiler = '.timeline__spoiler';
const cSpoilerActive = 'timeline__spoiler_active';
const sAnimTitle = '.timeline__line-item-title';
const sAnimPic = '.timeline__line-item-img-cont';
const sAnimAnons = '.timeline__line-item-anons';
const sAnimText = '.timeline__line-item-text';
let userScroll = false;
const persentWHForOpenedMin = -10; // %
const persentWHForOpened = 75; // %
const obTransform = {
    title: {
        start: { opacity: 0, top: 160 },
        end: { opacity: 1, top: 0 },
    },
    pic: {
        start: { opacity: 0, top: 120 },
        end: { opacity: 1, top: 0 },
    },
    anons: {
        start: { opacity: 0, top: 80 },
        end: { opacity: 1, top: 0 },
    },
    text: {
        start: { opacity: 0, top: 80 },
        end: { opacity: 1, top: 0 },
    },
};

function setBottomMenuFixed() {
    const cFixedMenuBottom = 'timeline__scroll-v_bottom';
    const $footer = $('.footer').first();
    const bottomOffset = 30;

    if ($fixedMenu.length && $footer.length) {
        $fixedMenu.removeClass(cFixedMenuBottom).removeAttr('style');

        const bottomFixedMenu = Math.round($(window).height() - ($fixedMenu.position().top + $fixedMenu.outerHeight()));
        const visibleHeightFooter = Math.round(
            ($(window).scrollTop() + $(window).height())
            - ($(document).height() - $footer.outerHeight() - bottomOffset),
        );

        if (visibleHeightFooter > bottomFixedMenu && !$fixedMenu.hasClass(cFixedMenuBottom)) {
            $fixedMenu.addClass(cFixedMenuBottom).css({ 'bottom': visibleHeightFooter });
        }
    }
}

function setSectionArr() {
    $section.each(function () {
        const $cur = $(this);
        const h = $cur.outerHeight(true);

        sectionArr[$cur.index()] = {
            el: $cur,
            num: parseInt($cur.attr('data-num')),
            height: h,
            top: $cur.offset().top,
            bottom: $cur.offset().top + h,
        };
    });
}

function setSliderFixed() {
    const headerHeight = $('.cheader').outerHeight();

    if ($scroll.length) {
        if (($(window).scrollTop() + headerHeight) >= $scroll.offset().top) {
            $scrollFF.addClass(cScrollFFFixed).css({ 'top': headerHeight });
        } else {
            $scrollFF.removeClass(cScrollFFFixed).removeAttr('style');
        }
    }
}

function owlEventSlide(e) {
    toSection(e.item.index);
}

function switchSection(n) {
    const num = n || 0;

    toSection(num);
    $(sSlider).trigger('to.owl.carousel', [num]);
}

function styleForSection(num) {
    $link.removeClass(cLinkActive);
    $linkV.removeClass(cLinkVActive);

    if (num !== false) {
        $link.eq(num).addClass(cLinkActive);
        $linkV.eq(num).addClass(cLinkVActive);
    }
}

function toSection(n) {
    const num = n || 0;

    styleForSection(num);
    scrollToSection(num);
    activeNum = num;
}

function getSectionIndex(n) {
    const num = n || 0;

    for (let i = 0; i < sectionArr.length; i++) {
        if (sectionArr[i].num === num) {
            return i;
        }
    }

    return false;
}

function scrollToSection(num) {
    const activeNumSectionIndex = getSectionIndex(activeNum);
    const sectIndex = getSectionIndex(num || 0);

    if (activeNumSectionIndex !== false && sectIndex !== false) {
        const $targetSection = sectionArr[sectIndex].el;

        if ($targetSection.length && $scrollFF.length) {
            const diff = Math.abs(activeNumSectionIndex - sectIndex) || 1;
            let curSpeed = speed * (diff * 2);
            const minCurSpeed = speed * 6;
            const $bodyForAnimate = $('html, body');
            let scrollFFHeight = 0;
            const windowHeight = $(window).height();
            const targetSectionTop = $targetSection.offset().top;
            const targetSectionHeight = $targetSection.height();
            const headerHeight = $('.cheader').outerHeight();

            if (getW() < eksmoBP.mdMin) {
                scrollFFHeight = $scrollFF.outerHeight();
            }

            const placeHeight = windowHeight - headerHeight - scrollFFHeight;
            let top = targetSectionTop - headerHeight - scrollFFHeight;
            const cssOffsetTop = 40;

            if (targetSectionHeight < placeHeight && getW() >= eksmoBP.smMin) {
                top -= Math.round((placeHeight - targetSectionHeight) / 2) - cssOffsetTop;
            }

            if (curSpeed < minCurSpeed) {
                curSpeed = minCurSpeed;
            }

            $bodyForAnimate.stop();
            $bodyForAnimate.animate({ scrollTop: top }, curSpeed, 'easeOutCubic');
        }
    }
}

function getCurSectionOnScroll() {
    const scrollTop = $(window).scrollTop();
    let scrollFFHeight = 0;
    const headerHeight = $('.cheader').outerHeight();
    const windowWidth = getW();
    const windowHeight = $(window).height();

    if (windowWidth < eksmoBP.mdMin) {
        scrollFFHeight = $scrollFF.outerHeight();
    }

    const placeTop = scrollTop + headerHeight + scrollFFHeight;
    const placeBottom = scrollTop + windowHeight;
    const placeHeight = placeBottom - placeTop;
    const placeCenter = placeTop + (placeHeight / 2);
    let afterScrollOffset = -100;

    if (windowWidth < eksmoBP.smMin) {
        afterScrollOffset = 0;
    }

    if (scrollTop) {
        for (let i = 0; i < sectionArr.length; i++) {
            const item = sectionArr[i];

            if (
                (item.top - afterScrollOffset) < placeCenter
                && (
                    (item.bottom - afterScrollOffset) > placeCenter
                    || (
                        windowWidth < eksmoBP.smMin
                        && (windowHeight / 2) > item.height
                        && item.bottom > (placeTop + 20)
                    )
                )
            ) {
                return item.num;
            }
        }
    }

    return false;
}

function setAfterScroll() {
    const num = getCurSectionOnScroll();

    activeNum = num;
    styleForSection(num);

    if (num !== false && $slider.length && userScroll) {
        $(sSlider).trigger('to.owl.carousel', [num]);
    }

    userScroll = false;
}

function animSections() {
    const scrollTop = $(window).scrollTop();
    let scrollFFHeight = 0;
    const headerHeight = $('.cheader').outerHeight();
    const windowWidth = getW();
    const windowHeight = $(window).height();

    if (windowWidth < eksmoBP.mdMin) {
        scrollFFHeight = $scrollFF.outerHeight();
    }

    const placeTop = scrollTop + headerHeight + scrollFFHeight;
    let placeBottom = scrollTop + windowHeight;
    const placeHeight = placeBottom - placeTop;
    const animPlaceTop = Math.round(placeBottom - ((placeHeight / 100) * persentWHForOpened));

    placeBottom -= (placeHeight / 100) * persentWHForOpenedMin;

    $section.each(function () {
        const $this = $(this);
        const $title = $this.find(sAnimTitle);
        const $pic = $this.find(sAnimPic);
        const $anons = $this.find(sAnimAnons);
        const $text = $this.find(sAnimText);
        const sectItem = sectionArr[$this.index()];
        const sectOffsetBottom = Math.round(placeBottom - sectItem.top);

        function setAnim(titleOpacity, titleTop, picOpacity, picTop, anonsOpacity, anonsTop, textOpacity, textTop) {
            $title.css({ 'opacity': titleOpacity, 'transform': `translateY(${titleTop}px)` });
            $pic.css({ 'opacity': picOpacity, 'transform': `translateY(${picTop}px)` });
            $anons.css({ 'opacity': anonsOpacity, 'transform': `translateY(${anonsTop}px)` });
            $text.css({ 'opacity': textOpacity, 'transform': `translateY(${textTop}px)` });
        }

        if (sectOffsetBottom > 0) {
            const sectOffsetBottomPercent = Math.round((sectOffsetBottom / (placeBottom - animPlaceTop)) * 100);

            if (sectOffsetBottomPercent <= 100) {
                setAnim(
                    obTransform.title.start.opacity
                    + ((obTransform.title.end.opacity - obTransform.title.start.opacity) / 100)
                    * sectOffsetBottomPercent,
                    obTransform.title.start.top
                    + ((obTransform.title.end.top - obTransform.title.start.top) / 100)
                    * sectOffsetBottomPercent,
                    obTransform.pic.start.opacity
                    + ((obTransform.pic.end.opacity - obTransform.pic.start.opacity) / 100)
                    * sectOffsetBottomPercent,
                    obTransform.pic.start.top
                    + ((obTransform.pic.end.top - obTransform.pic.start.top) / 100)
                    * sectOffsetBottomPercent,
                    obTransform.anons.start.opacity
                    + ((obTransform.anons.end.opacity - obTransform.anons.start.opacity) / 100)
                    * sectOffsetBottomPercent,
                    obTransform.anons.start.top
                    + ((obTransform.anons.end.top - obTransform.anons.start.top) / 100)
                    * sectOffsetBottomPercent,
                    obTransform.text.start.opacity
                    + ((obTransform.text.end.opacity - obTransform.text.start.opacity) / 100)
                    * sectOffsetBottomPercent,
                    obTransform.text.start.top
                    + ((obTransform.text.end.top - obTransform.text.start.top) / 100)
                    * sectOffsetBottomPercent,
                );
            } else {
                setAnim(
                    obTransform.title.end.opacity,
                    obTransform.title.end.top,
                    obTransform.pic.end.opacity,
                    obTransform.pic.end.top,
                    obTransform.anons.end.opacity,
                    obTransform.anons.end.top,
                    obTransform.text.end.opacity,
                    obTransform.text.end.top,
                );
            }
        } else {
            setAnim(
                obTransform.title.start.opacity,
                obTransform.title.start.top,
                obTransform.pic.start.opacity,
                obTransform.pic.start.top,
                obTransform.anons.start.opacity,
                obTransform.anons.start.top,
                obTransform.text.start.opacity,
                obTransform.text.start.top,
            );
        }
    });
}

onScreen($headerPic, ($pic) => {
    if ($pic.hasClass('timeline__header-pic-d')) {
        $pic.on('eksmoImgLoadSrcOrBg', () => {
            $pic.addClass(cHeaderPicDLoaded);
        });
    }

    loadSrcOrBg($pic);
});

$link.removeClass(cLinkActive);
$link.eq(0).addClass(cLinkActive);
setSectionArr();
setAfterScroll();
setSliderFixed();

if (getW() >= eksmoBP.smMin) {
    animSections();
}

if (getW() >= eksmoBP.mdMin) {
    setBottomMenuFixed();
}

$(window).on('load', () => {
    $slider.trigger('destroy.owl.carousel')
        .removeClass(cSliderOn)
        .addClass(cSliderOn)
        .owlCarousel({
            smartSpeed: speed,
            dots: false,
            nav: false,
            center: true,
            autoWidth: true,
            items: 1,
        })
        .on('dragged.owl.carousel', owlEventSlide);
});

$(sLink).on('click', function () {
    switchSection($(this).closest('.owl-item').index());
});

$(sLinkV).on('click', function () {
    switchSection($(this).index());
});

$arrow.on('click', () => {
    toSection(0);
});

$spoilerLink.on('click', function (e) {
    e.preventDefault();
    $(this).closest(sSpoiler).addClass(cSpoilerActive);
    setSectionArr();

    if (getW() >= eksmoBP.smMin) {
        animSections();
    }
});

$('body').on('eksmoResizeWidth', () => {
    setSectionArr();
    $(sSlider).trigger('to.owl.carousel', [activeNum]);
    setBottomMenuFixed();
});

$(window).on('scroll', setBottomMenuFixed);

$(window).on('scroll resize', () => {
    setSliderFixed();

    if (getW() >= eksmoBP.smMin) {
        animSections();
    }
});

$(window).on('scroll resize', $.debounce(speed / 2, () => {
    userScroll = true;
    setAfterScroll();
}));

const $timelineSections = $('.timeline__section');

$(window).on('scroll', $.debounce(speed / 2, function () {
    const curPos = $(this).scrollTop() + 300;

    $timelineSections.each(function () {
        const thisOffset = $(this).offset().top;

        if (curPos >= thisOffset) {
            console.log(curPos, thisOffset);
            $fixedMenu.find('.timeline__scroll-v-item').removeClass('timeline__scroll-v-item_active');
            $fixedMenu.find(`.timeline__scroll-v-item[href="#${$(this).attr('id')}"]`).addClass('timeline__scroll-v-item_active');
        }
    });
}));

$(window).on('scroll', function () {

});